export default {
  title: {
    id: 'product_page_telco_calculator_advertisement_title',
    defaultMessage: 'Buy smarter. Save thousands.',
  },
  subtitle: {
    id: 'product_page_telco_calculator_advertisement_subtitle',
    defaultMessage: 'Don’t be fooled by a “free” upgrade.',
  },
}
